import { useEffect, useState } from 'react';

/* ==================================================================
   useMotionPrefs
   ------------------------------------------------------------------
   One place that answers "how much motion is appropriate here?".

   reduced  - the visitor asked for reduced motion; skip every
              decorative loop and land elements in their final state.
   pointer  - a real hovering pointer exists, so cursor-reactive and
              magnetic effects are worth wiring up (never on touch).
   wide     - viewport is large enough for the pinned / horizontal
              scroll choreography.
   ================================================================== */

const QUERIES = {
  reduced: '(prefers-reduced-motion: reduce)',
  pointer: '(hover: hover) and (pointer: fine)',
  wide: '(min-width: 920px)',
};

function read() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return { reduced: false, pointer: false, wide: true };
  }
  return {
    reduced: window.matchMedia(QUERIES.reduced).matches,
    pointer: window.matchMedia(QUERIES.pointer).matches,
    wide: window.matchMedia(QUERIES.wide).matches,
  };
}

export default function useMotionPrefs() {
  const [prefs, setPrefs] = useState(read);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const lists = Object.values(QUERIES).map((q) => window.matchMedia(q));
    const onChange = () => setPrefs(read());
    lists.forEach((list) => {
      if (list.addEventListener) list.addEventListener('change', onChange);
      else list.addListener(onChange);
    });
    return () => {
      lists.forEach((list) => {
        if (list.removeEventListener) list.removeEventListener('change', onChange);
        else list.removeListener(onChange);
      });
    };
  }, []);

  return prefs;
}
